import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, MintComponentFragmentDoc } from '@graphql/reactQuery';
import { useSubscribeRelease } from '@hooks/useSubscribeRelease';
import { createContainerStrict } from '@utils/unstated-strict';
import { useMintState } from './useMintState';

type MintComponentContextType = {
  release: FragmentType<MintComponentFragmentDoc>;
};

const MintComponent = createContainerStrict(function useMintComponent(
  initialState: MintComponentContextType,
) {
  const initialRelease = initialState?.release;

  const release = getFragment(MintComponentFragmentDoc, initialRelease);

  const {
    data: { isFirstPhaseCompleted, totalMinted },
  } = useSubscribeRelease({
    release,
  });

  const mintState = useMintState({
    release,
    chainId: release.chainId,
    editionAddress: release.contract.contractAddress,
    contractType: release.contract.contractType,
    isFirstPhaseCompleted,
    rootTotalMinted: totalMinted,
    finalQuantity: release.finalQuantity,
  });

  return {
    ...mintState,
    totalMinted,
    isFirstPhaseCompleted,
  };
});

export const useMintComponent = () => MintComponent.useContainer();

export const MintComponentContext = MintComponent.Context;
export const MintComponentProvider = MintComponent.Provider;
